class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '86d5f828';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1200.0.5';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Thu, 01 Oct 2026 17:14:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2026-10-01 13:13:51 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2026-10-01 13:13:51 Boston - 86d5f828 - 1200.0.5';
export default BuildTags;
